//@ts-check
import _ from 'lodash';
/*
LINE WOKRSモーダル内で検索条件関係を取り扱うクラスや関数。
「_」付きの変数を直接取得・変更してはならない。
(プライベート宣言はESLint非対応のため未使用)
*/

class FullName {
  _fullName = '';

  /**
   * フルネームを格納するクラス
   * @param {string} fullName - フルネーム
   **/
  constructor(fullName) {
    this._fullName = fullName;
  }

  get value() {
    return this._fullName;
  }

  isBlank() {
    return this._fullName === '';
  }

  /**
   * フルネームが一致しているか
   * @param {FullName} checkedFullName - フルネームクラス
   * @return {boolean}
   **/
  isEqual(checkedFullName) {
    return this._fullName === checkedFullName.value;
  }
}

class PartnerCompany1Ids {
  _partnerCompany1Ids = [];

  /**
   * 一次協力会社のリストを格納するクラス
   * @param {array} partnerCompany1Ids - 一次協力会社のリスト
   **/
  constructor(partnerCompany1Ids) {
    this._partnerCompany1Ids = _.cloneDeep(partnerCompany1Ids);
    Object.freeze(this._partnerCompany1Ids);
  }

  get list() {
    return this._partnerCompany1Ids;
  }

  isBlank() {
    return this._partnerCompany1Ids.length === 0;
  }

  /**
   * 一次協力会社が一致しているか
   * @param {PartnerCompany1Ids} checkedPartnerCompany1Ids - 一次協力会社クラス
   **/
  isEqual(checkedPartnerCompany1Ids) {
    return _.isEqual(this._partnerCompany1Ids, checkedPartnerCompany1Ids.list);
  }
}

class RoleCodes {
  _roleCodes = [];

  /**
   * ロールコードのリストを格納するクラス
   * @param {array} roleCodes - ロールコードのリスト
   **/
  constructor(roleCodes) {
    this._roleCodes = _.cloneDeep(roleCodes);
    Object.freeze(this._roleCodes);
  }

  get list() {
    return this._roleCodes;
  }

  isBlank() {
    return this._roleCodes.length === 0;
  }

  /**
   * ロールコードが一致しているか
   * @param {RoleCodes} checkedRoleCodes - ロールコードクラス
   **/
  isEqual(checkedRoleCodes) {
    return _.isEqual(this._roleCodes, checkedRoleCodes.list);
  }
}

class SearchCondition {
  /** @type {FullName} **/
  _fullName;
  /** @type {PartnerCompany1Ids} **/
  _partnerCompany1Ids;
  /** @type {RoleCodes} **/
  _roleCodes;

  /**
   * 検索条件の格納クラス
   * @param {null | FullName} fullName - フルネームクラス
   * @param {null | PartnerCompany1Ids} partnerCompany1Ids - 一次協力会社クラス
   * @param {null | RoleCodes} roleCodes - ロールコードクラス
   **/
  constructor(fullName = null, partnerCompany1Ids = null, roleCodes = null) {
    if (fullName === null) {
      this._fullName = new FullName('');
    } else {
      this._fullName = fullName;
    }

    if (partnerCompany1Ids === null) {
      this._partnerCompany1Ids = new PartnerCompany1Ids([]);
    } else {
      this._partnerCompany1Ids = partnerCompany1Ids;
    }

    if (roleCodes === null) {
      this._roleCodes = new RoleCodes([]);
    } else {
      this._roleCodes = roleCodes;
    }
  }

  getAPIParamertes() {
    // APIで使われることを想定して、不要な値はキーを設定しない。
    const parameters = {};
    if (!this._fullName.isBlank()) {
      // APIにはfullname(アンダーバー無し)を渡す
      parameters.fullname = this._fullName.value;
    }
    if (!this._partnerCompany1Ids.isBlank()) {
      parameters.partner_company_1_ids = this._partnerCompany1Ids.list;
    }
    if (!this._roleCodes.isBlank()) {
      parameters.role_codes = this._roleCodes.list;
    }
    return Object.freeze(parameters);
  }

  get fullName() {
    return this._fullName;
  }

  get partnerCompany1Ids() {
    return this._partnerCompany1Ids;
  }

  get roleCodes() {
    return this._roleCodes;
  }

  /**
   * @param {FullName} fullName - フルネームクラス
   **/
  setFullName(fullName) {
    // 更新があった時だけ新しくオブジェクトを作る
    if (this._fullName.isEqual(fullName)) {
      return this;
    }
    return new SearchCondition(
      fullName,
      this._partnerCompany1Ids,
      this._roleCodes
    );
  }

  /**
   * @param {PartnerCompany1Ids} partnerCompany1Ids - 1次協力会社クラス
   **/
  setPartnerCompany1Ids(partnerCompany1Ids) {
    // 更新があった時だけ新しくオブジェクトを作る
    if (this._partnerCompany1Ids.isEqual(partnerCompany1Ids)) {
      return this;
    }
    return new SearchCondition(
      this._fullName,
      partnerCompany1Ids,
      this._roleCodes
    );
  }

  /**
   * @param {RoleCodes} roleCodes - ロールコードクラス
   **/
  setRoleCodes(roleCodes) {
    // 更新があった時だけ新しくオブジェクトを作る
    if (this._roleCodes.isEqual(roleCodes)) {
      return this;
    }
    return new SearchCondition(
      this._fullName,
      this._partnerCompany1Ids,
      roleCodes
    );
  }
}

export { FullName, PartnerCompany1Ids, RoleCodes, SearchCondition };



// WEBPACK FOOTER //
// ./src/services/lwUser/SearchCondition.js